import React from "react";
import Music from "../Components/Music";
import Dance from "../Components/Dance";
import Photography from "../Components/Photography";
import Empowerment from "../Components/Empowerment";
import EventButtons from "../Components/EventButtons";
import { Nav } from "../Components/Nav";
import Poetry from "../Components/Poetry";
import Comedy from "../Components/Comedy";

export const Events = () => {
  return (
    <>
      <Nav />
      <Music />
      <Dance />
      <Poetry />
      <Comedy/>
      <Empowerment />
      <Photography />
      <EventButtons />
    </>
  );
};
